import { motion } from 'framer-motion';
import { TextReveal } from '@/hooks/useAnimations';

const KVKKPage = () => (
  <div data-testid="kvkk-page" className="bg-white">
    <section className="page-hero-banner" style={{ minHeight: '280px' }}>
      <div className="absolute inset-0 bg-[#0B3A82]" />
      <div className="hero-inner">
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="max-w-2xl">
          <h1 className="heading-xl text-white mb-4">KVKK Aydınlatma Metni</h1>
          <p className="text-base text-white/70">Kişisel Verilerin Korunması Kanunu kapsamında bilgilendirme.</p>
        </motion.div>
      </div>
    </section>

    <section className="section-white section-padding">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div className="prose prose-slate max-w-none space-y-8">
          <TextReveal>
            <div>
              <h2 className="text-xl font-bold text-[#0B3A82] mb-4">1. Veri Sorumlusu</h2>
              <p className="text-body leading-relaxed">
                Asküçükler Lojistik ("Şirket"), 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında veri sorumlusu sıfatıyla, kişisel verilerinizi aşağıda açıklanan amaçlar doğrultusunda işlemektedir.
              </p>
            </div>
          </TextReveal>

          <TextReveal delay={0.05}>
            <div>
              <h2 className="text-xl font-bold text-[#0B3A82] mb-4">2. İşlenen Kişisel Veriler</h2>
              <p className="text-body leading-relaxed mb-3">İletişim formumuz aracılığıyla aşağıdaki veriler toplanmaktadır:</p>
              <ul className="list-disc pl-6 space-y-2 text-[#64748B]">
                <li>Firma adı ve yetkili kişi bilgileri</li>
                <li>E-posta adresi ve telefon numarası</li>
                <li>Taşıma talebi detayları (güzergah, hacim, taşıma türü)</li>
              </ul>
            </div>
          </TextReveal>

          <TextReveal delay={0.1}>
            <div>
              <h2 className="text-xl font-bold text-[#0B3A82] mb-4">3. Verilerin İşlenme Amacı</h2>
              <ul className="list-disc pl-6 space-y-2 text-[#64748B]">
                <li>Teklif taleplerinin değerlendirilmesi ve yanıtlanması</li>
                <li>Müşteri ilişkilerinin yönetimi</li>
                <li>Hizmet kalitesinin iyileştirilmesi</li>
                <li>Yasal yükümlülüklerin yerine getirilmesi</li>
              </ul>
            </div>
          </TextReveal>

          <TextReveal delay={0.15}>
            <div>
              <h2 className="text-xl font-bold text-[#0B3A82] mb-4">4. Verilerin Aktarılması</h2>
              <p className="text-body leading-relaxed">
                Kişisel verileriniz, yasal zorunluluklar haricinde üçüncü taraflarla paylaşılmamaktadır.
              </p>
            </div>
          </TextReveal>

          <TextReveal delay={0.2}>
            <div>
              <h2 className="text-xl font-bold text-[#0B3A82] mb-4">5. Haklarınız</h2>
              <p className="text-body leading-relaxed mb-3">KVKK'nın 11. maddesi kapsamında aşağıdaki haklara sahipsiniz:</p>
              <ul className="list-disc pl-6 space-y-2 text-[#64748B]">
                <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                <li>İşlenmişse buna ilişkin bilgi talep etme</li>
                <li>Verilerin düzeltilmesini veya silinmesini isteme</li>
                <li>İşlemenin kısıtlanmasını talep etme</li>
              </ul>
            </div>
          </TextReveal>

          <TextReveal delay={0.25}>
            <div>
              <h2 className="text-xl font-bold text-[#0B3A82] mb-4">6. İletişim</h2>
              <p className="text-body leading-relaxed">
                KVKK kapsamındaki talepleriniz için <a href="mailto:info@askucukler.com" className="text-[#FF6B2C] hover:underline font-medium">info@askucukler.com</a> adresine e-posta gönderebilirsiniz.
              </p>
            </div>
          </TextReveal>

          <TextReveal delay={0.3}>
            <div>
              <h2 className="text-xl font-bold text-[#0B3A82] mb-4">7. Çerez Politikası</h2>
              <p className="text-body leading-relaxed">
                Web sitemiz, kullanıcı deneyimini iyileştirmek amacıyla çerezler kullanmaktadır. Çerezler, tarayıcınız tarafından cihazınıza kaydedilen küçük metin dosyalarıdır. Zorunlu çerezler sitenin düzgün çalışması için gereklidir. Sitemizi kullanmaya devam ederek çerez kullanımını kabul etmiş sayılırsınız.
              </p>
            </div>
          </TextReveal>
        </div>
      </div>
    </section>
  </div>
);

export default KVKKPage;
